import MODELS from "./models/index_b";
import CONTROLLERS from "./controllers";
import SERVICES from "./services";
import MODULES from "./modules";
import { CONTEXTS } from "./context";
import { cacheFeedPosts, getCachedFeedPosts, makeFeedKey } from './services/FeedCacheDb';
import { cacheDatabaseHome, getCachedDatabaseHome, makeDatabaseHomeKey } from './services/DatabaseCacheDb';
import { cacheWidget, getCachedWidget, makeWidgetKey } from './services/WidgetsCacheDb';
import { OTP_TYPES } from './controllers/AuthController';
import { STICKER_TYPES } from './modules/Enumeration';
import { constants } from './modules/Constants';
import SearchService from './services/SearchService';
import defaultDatabaseAds from './assets/images/defaults/default_database_ads.png';

// Re-export commonly used hooks for convenience
const { useAuth, useAPI, useTheme, useMessages, useNotifications } = CONTEXTS;

export { MODELS, CONTROLLERS, SERVICES, MODULES, CONTEXTS, useAuth, useAPI, useTheme, useMessages, useNotifications, cacheFeedPosts, getCachedFeedPosts, makeFeedKey, cacheDatabaseHome, getCachedDatabaseHome, makeDatabaseHomeKey, cacheWidget, getCachedWidget, makeWidgetKey, OTP_TYPES, STICKER_TYPES, constants, SearchService, defaultDatabaseAds };